import { InjectionToken } from '@angular/core';
export interface ConfigOptions {
  host: string;
  application: string;
}

export const ConfigService = new InjectionToken<ConfigOptions>('ConfigOptions');
